interface Service {
  label: string;
  description: string;
  price: string;
  cycle: string;
  since: string;
  next: string;
  status: 'active' | 'pending';
}

const services: Service[] = [
  {
    label: 'SEO optimalizácia',
    description: 'Mesačná správa SEO, technický audit, linkbuilding',
    price: '149 €',
    cycle: 'mesačne',
    since: '1.1.2025',
    next: '1.4.2025',
    status: 'active',
  },
  {
    label: 'Google Ads správa',
    description: 'Tvorba a optimalizácia kampaní, A/B testovanie',
    price: '199 €',
    cycle: 'mesačne',
    since: '1.1.2025',
    next: '1.4.2025',
    status: 'active',
  },
  {
    label: 'Social media management',
    description: 'Správa Instagram & Facebook, 16 príspevkov/mes',
    price: '299 €',
    cycle: 'mesačne',
    since: '15.1.2025',
    next: '15.4.2025',
    status: 'active',
  },
  {
    label: 'Redesign e-shopu',
    description: 'Kompletný redesign, UX analýza, vývoj na Shopify',
    price: '1 490 €',
    cycle: 'jednorazovo',
    since: '1.3.2025',
    next: '–',
    status: 'active',
  },
];

export default function PortalSluzby() {
  return (
    <div className="p-6 flex flex-col gap-5 overflow-y-auto h-full">
      {/* Services list */}
      <div className="bg-zinc-900 border border-zinc-800 rounded-2xl overflow-hidden">
        <div className="px-5 py-3.5 border-b border-zinc-800 flex items-center justify-between">
          <p className="text-white font-bold text-sm">Aktívne služby</p>
          <span className="text-zinc-500 text-xs">{services.length} služby</span>
        </div>
        <div className="divide-y divide-zinc-800/50">
          {services.map((s) => (
            <div key={s.label} className="px-5 py-4 flex items-center gap-4 hover:bg-zinc-800/20 transition-all">
              <div className="w-9 h-9 bg-orange-500/10 border border-orange-500/20 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-service-line text-orange-400 text-sm" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-zinc-200 text-sm font-semibold">{s.label}</p>
                <p className="text-zinc-500 text-xs mt-0.5 truncate">{s.description}</p>
              </div>
              <div className="text-center flex-shrink-0 hidden sm:block">
                <p className="text-zinc-500 text-[10px] uppercase tracking-wide">Faktur.</p>
                <p className="text-zinc-300 text-xs font-medium mt-0.5">{s.cycle}</p>
              </div>
              <div className="text-center flex-shrink-0 hidden md:block">
                <p className="text-zinc-500 text-[10px] uppercase tracking-wide">Ďalšia platba</p>
                <p className="text-zinc-300 text-xs font-medium mt-0.5">{s.next}</p>
              </div>
              <div className="text-right flex-shrink-0">
                <p className="text-white text-sm font-bold">{s.price}</p>
                <span className="mt-1 inline-block bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-[9px] px-2 py-0.5 rounded-full font-semibold">Aktívna</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Summary */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-orange-500/5 border border-orange-500/15 rounded-2xl px-5 py-4 flex items-center justify-between">
          <div>
            <p className="text-zinc-400 text-xs mb-1">Mesačné opakujúce sa náklady</p>
            <p className="text-white font-black text-2xl leading-none">647 €<span className="text-zinc-500 text-sm font-medium">/mes</span></p>
          </div>
          <div className="w-12 h-12 flex items-center justify-center bg-orange-500/10 border border-orange-500/20 rounded-xl">
            <i className="ri-repeat-line text-orange-400 text-lg" />
          </div>
        </div>
        <div className="bg-zinc-900 border border-zinc-800 rounded-2xl px-5 py-4 flex items-center justify-between">
          <div>
            <p className="text-zinc-500 text-xs mb-1">Ďalšia fakturácia</p>
            <p className="text-white font-bold text-base">1. apríl 2025</p>
            <p className="text-zinc-600 text-xs mt-0.5">mesačné služby</p>
          </div>
          <div className="w-12 h-12 flex items-center justify-center bg-zinc-800 border border-zinc-700 rounded-xl">
            <i className="ri-calendar-line text-zinc-400 text-lg" />
          </div>
        </div>
      </div>
    </div>
  );
}
